<template>
  <div>
    <toast v-if="active" kind="error">
      <template #message-content>
        {{ errorMessage }}
      </template>
    </toast>
  </div>
</template>

<script>
import ajax from '@/helpers/ajax'
import { inject } from 'vue'
import Toast from '@/components/toast'

const TOAST_TIMEOUT = 5000

export default {
  components: { Toast },

  props: {
    messageForNonOkHttpStatus: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('errors.ajax.server_error') }
    }
  },

  data() {
    return {
      active: false,
      errorDetail: {
        errorType: null
      }
    }
  },

  computed: {
    errorMessage() {
      switch (this.errorDetail.errorType) {
      case ajax.errorTypes.FETCH_FAILED:
        return this.i18n.t('errors.ajax.network_failure')
      case ajax.errorTypes.NOT_OK_HTTP_STATUS:
        if (this.errorDetail.httpStatusCode === 422 && this.errorDetail.message === 'Invalid authenticity token') {
          return this.i18n.t('errors.ajax.invalid_authenticity_token')
        } else {
          return this.messageForNonOkHttpStatus
        }
      default:
        return this.i18n.t('errors.something_wrong')
      }
    }
  },

  mounted() {
    document.addEventListener('agra:ajax-error', (evt) => {
      this.errorDetail = evt.detail
      this.active = true

      setTimeout(() => {
        this.active = false
      }, TOAST_TIMEOUT)
    })
  }
}
</script>
